import { render, staticRenderFns } from "./books.vue?vue&type=template&id=6dc4b7c9&scoped=true"
import script from "./books.vue?vue&type=script&lang=ts"
export * from "./books.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc4b7c9",
  null
  
)

export default component.exports